// extracted by mini-css-extract-plugin
export var navigationWrapper = "Slider-module--navigationWrapper--1Qp_q";
export var dots = "Slider-module--dots--3qdD5";
export var dot = "Slider-module--dot--3ACWR";
export var arrow = "Slider-module--arrow--31e0E";
export var arrowLeft = "Slider-module--arrowLeft--pw0ER";
export var arrowRight = "Slider-module--arrowRight--U4LkR";
export var arrowDisabled = "Slider-module--arrowDisabled--2HP2e";